module.exports = __webpack_public_path__ + "img/login-bg-flight.222bdc7a.svg";